import {
  ForwardRefRenderFunction,
  ReactNode,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'

import { Modal } from '@hhgtech/hhg-components/mantine'
import { rem } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'

export type HandlerProps = {
  open: () => void
  close: () => void
  isOpen: boolean
}

export type RiskScreenerModalProps = {
  children: ReactNode
  isTypeForm?: boolean
  onOpen?: () => void
}

const RiskScreenerModal: ForwardRefRenderFunction<
  HandlerProps,
  RiskScreenerModalProps
> = ({ isTypeForm, onOpen, children }, ref) => {
  const isMobile = useIsMobile()
  const [isOpen, setOpen] = useState(false)
  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
    isOpen,
  }))

  useEffect(() => {
    if (isMobile) {
      const zaloEles = document.querySelectorAll<HTMLDivElement>(
        '.zalo-chat-widget',
      )
      const chatwootEles = document.querySelectorAll<HTMLDivElement>(
        '.woot--bubble-holder',
      )
      if (zaloEles) {
        for (const zaloEle of zaloEles) {
          zaloEle.style.display = isOpen ? 'none' : 'block'
        }
      }
      if (chatwootEles) {
        for (const chatwootEle of chatwootEles) {
          chatwootEle.style.display = isOpen ? 'none' : 'block'
        }
      }
    }
    isOpen && onOpen?.()
  }, [isOpen])

  return (
    <Modal
      opened={isOpen}
      onClose={() => setOpen(false)}
      centered
      fullScreen={isMobile}
      zIndex={500}
      keepMounted={isTypeForm}
      styles={(theme) => ({
        content: {
          [theme.fn.smallerThan('sm')]: {
            ...(isTypeForm && {
              borderRadius: 0,
            }),
          },
          [theme.fn.largerThan('sm')]: {
            borderRadius: rem(24),
            ...(isTypeForm && {
              'div, iframe': {
                borderRadius: rem(24),
              },
            }),
          },
        },
        header: {
          position: 'absolute',
          right: 0,
          top: 0,
          background: 'transparent',
          border: 0,
        },
        body: {
          padding: 0,
          borderRadius: 'inherit',
          height: '100%',
          ...(isTypeForm && {
            div: {
              height: '100%',
              maxHeight: 'none',
            },
            iframe: {
              borderRadius: '0 !important',
            },
            '.tf-v1-widget-close': {
              display: 'none',
            },
            [theme.fn.largerThan('sm')]: {
              height: 656,
              '.si-inline-revamp-container': {
                padding: '40px 24px 24px',
              },
              '.si-typeform': {
                height: '100% !important',
                maxHeight: 'none !important',
              },
            },
            [theme.fn.smallerThan('sm')]: {
              height: '100%',
              borderRadius: 0,
            },
          }),
        },
        close: {
          ...(isTypeForm && {
            right: -11,
            top: -9,
            svg: {
              width: `${rem(32)} !important`,
              height: `${rem(32)} !important`,
            },
          }),
        },
      })}
      size={isTypeForm ? 400 : 640}
      title={''}
      withCloseButton={isTypeForm || !isMobile}
    >
      {children}
    </Modal>
  )
}

export default forwardRef(RiskScreenerModal)
